import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import OtpVerification from "./OtpVerification";
import ResetPasswordStep from "./ResetPasswordStep";
import { useNavigate } from "react-router-dom";

const ForgetPasswordSteps = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const next = () => setStep(step + 1);
  const back = () => setStep(step - 1);


  const goToLogin = () => {
    navigate("/login");
  };
  return (
    <Container fluid className="auth-layout">
      <Row className="full-height">
        <Col md={6} className="auth-side d-none d-md-flex align-items-center">
          <div className="auth-content">
            <h1>Reset your access</h1>
            <p className="opacity-75">Step {step} of 4</p>
          </div>
        </Col>

        <Col md={6} className="flex-center">
          <div className="card-box">
            <h3 className="heading-lg text-center mb-4">
              {step === 2
                ? "Verify OTP"
                : step === 3
                  ? "Set New Password"
                  : step === 4
                    ? "Password Updated 🎉"
                    : "Forgot Password"}
            </h3>

            {step === 1 && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    className="form-input"
                  />
                </Form.Group>

                <Button className="w-100 btn-primary-custom" onClick={next}>
                  Send OTP
                </Button>
                <p className="text-center text-muted-sm mt-3">
                  Remember password?{" "}
                  <a href="/login">
                    <span className="link-primary">Sign in</span>
                  </a>
                </p>
              </>
            )}

            {step === 2 && <OtpVerification onVerified={next} back={back} />}

            {step === 3 && <ResetPasswordStep onSuccess={next} back={back} />}

            {step === 4 && (
              <div className="text-center">
                <p className="text-muted-sm">
                  Your password has been reset successfully.
                </p>
                <Button
                  className="btn-primary-custom w-100 mt-3"
                  onClick={goToLogin}
                >
                  Go to Login
                </Button>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgetPasswordSteps;
